import Event from '../../core/Event';
import Customer from '../../../domain/Customer';

export default class CustomerUpdatedSucceed extends Event {
    public static type = 'CustomerUpdatedSucceed';

    constructor(public readonly customerId: string, public readonly user: Partial<Customer>) {
        super(CustomerUpdatedSucceed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/admin/events/CustomerUpdatedSucceed.ts